module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "copyright-page",
      "id": "copy"
    }
  }, [_c('p', {
    staticClass: "copyt"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iv",
      "title": "iv"
    }
  }, [_vm._v("To all the people who are there for us during this"), _c('br'), _vm._v("pandemic and for Stacey, always!")])]), _vm._v(" "), _c('p', {
    staticClass: "copyr"
  }, [_vm._v("—H.W.")]), _vm._v(" "), _c('p', {
    staticClass: "copys"
  }, [_vm._v("For Theo, Oliver, and Cole . . . who grew from"), _c('br'), _vm._v("our boys to fine men.")]), _vm._v(" "), _c('p', {
    staticClass: "copyr"
  }, [_vm._v("—L.O.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt1"
  }, [_vm._v("PUBLISHER’S NOTE: This is a work of fiction. Names, characters, places, and incidents are either the product of the author’s imagination or used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events, or locales is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Cataloging-in-Publication Data has been applied for and may be obtained from the Library of Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN 978-1-4197-4099-2"), _c('br'), _vm._v("eISBN 978-1-68335-864-0")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Text copyright © 2020 Henry Winkler and Lin Oliver")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Illustrations copyright © 2020 Ethan Nicolle")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Book design by Marcie Lawrence")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Published in 2020 by Amulet Books, an imprint of ABRAMS. All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, mechanical, electronic, photocopying, recording, or otherwise, without written permission from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Amulet Books are available at special discounts when purchased in quantity for premiums and promotions as well as fundraising or educational use. Special editions can also be created to specification. For details, contact specialsales@abramsbooks.com or the address below.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Amulet Books® is a registered trademark of Harry N. Abrams, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1s"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/copya.jpg"
    }
  }), _c('br'), _c('strong', [_vm._v("ABRAMS")]), _vm._v(" The Art of Books"), _c('br'), _vm._v("195 Broadway, New York, NY 10007"), _c('br'), _c('a', {
    attrs: {
      "href": "http://abramsbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("abramsbooks.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff349114","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copy.vue
// module id = 63
// module chunks = 0